'use strict';

angular.module('userSettings')

.controller('UserSettingsCtrl', function (
    $scope,
    $http,
    $filter,
    $uibModalInstance,
    DS,
    User,
    kdAuth
) {
    this.user = kdAuth.user;

    this.userUpdates = {
        name: this.user.name,
        last_name: this.user.last_name,
        email: this.user.email,
        dob: this.user.dob,
        team: this.user.team,
        gender: this.user.gender,
        newsletter: this.user.newsletter,
        agree_uefa: this.user.agree_uefa,
        agree_partners: this.user.agree_partners
    };

    this.submit = function ()
    {
        this.error = null;

        var user = angular.copy(this.user);

        user.dob = $filter('date')(user.dob, "yyyy-MM-dd");

        User.update(this.user.id, user)
            .then(function(data) {
                $uibModalInstance.dismiss();
            });
    };

    this.onBadResponse = function (response)
    {
        if (response.status === 422) {
            return;
        }

        if (response.status === 500) {
            this.error = 'Something went wrong, please try again later.';
            return;
        }

        this.error = response.data;
    };
});
